import React, { Component } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';

import Navigation from '../components/onboarding/ui/navigation';
import Pagination from '../components/onboarding/ui/pagination';
import Page404 from '../../components/onboarding/Page404';

import WelcomeStep1 from '../components/onboarding/welcome/step1';
import WelcomeStep2 from '../components/onboarding/welcome/step2';
import WelcomeStep3 from '../components/onboarding/welcome/step3';
import WelcomeStep4 from '../components/onboarding/welcome/step4';

import GameOverviewStep1 from '../components/onboarding/game-overview/step1';
import GameOverviewStep2 from '../components/onboarding/game-overview/step2';
import GameOverviewStep3 from '../components/onboarding/game-overview/step3';
import GameOverviewStep4 from '../components/onboarding/game-overview/step4';

import SettingUpGameplayStep1 from '../components/onboarding/setting-up-gameplay/step1';
import SettingUpGameplayStep2 from '../components/onboarding/setting-up-gameplay/step2';
import SettingUpGameplayStep3 from '../components/onboarding/setting-up-gameplay/step3';
import SettingUpGameplayStep4 from '../components/onboarding/setting-up-gameplay/step4';

import HowGradingWorksStep1 from '../components/onboarding/how-grading-works/step1';
import HowGradingWorksStep2 from '../components/onboarding/how-grading-works/step2';
import HowGradingWorksStep3 from '../components/onboarding/how-grading-works/step3';
import HowGradingWorksStep4 from '../components/onboarding/how-grading-works/step4';
import HowGradingWorksStep5 from '../components/onboarding/how-grading-works/step5';

import WhatToExpectStep1 from '../components/onboarding/what-to-expect/step1';
import WhatToExpectStep2 from '../components/onboarding/what-to-expect/step2';
import WhatToExpectStep3 from '../components/onboarding/what-to-expect/step3';
import WhatToExpectStep4 from '../components/onboarding/what-to-expect/step4';
import WhatToExpectStep5 from '../components/onboarding/what-to-expect/step5';

import HowWeSupportYou from '../components/onboarding/how-we-support-you';
import NextSteps from '../components/onboarding/next-steps';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

class InstructorOnboardingPage extends Component {

  constructor(props) {
    super(props);

    console.log('this.activeRound', this.activeRound);

    this.state = {
      pages: [
        { component: WelcomeStep1, group: 'Welcome', url: 'welcome' },
        ...(this.activeRound > 1
          ? [
            { component: WelcomeStep2, group: 'Welcome', url: 'welcome/intro' },
            { component: WelcomeStep3, group: 'Welcome', url: 'welcome/pros' },
            { component: WelcomeStep4, group: 'Welcome', url: 'welcome/learning-objectives' },
            { component: GameOverviewStep1, group: 'Game Overview', url: 'game-overview/market-opportunity' },
            { component: GameOverviewStep2, group: 'Game Overview', url: 'game-overview/segments' },
            { component: GameOverviewStep3, group: 'Game Overview', url: 'game-overview/goals-and-targets' },
            { component: GameOverviewStep4, group: 'Game Overview', url: 'game-overview/roles' },
            { component: SettingUpGameplayStep1, group: 'Setting Up Gameplay', url: 'setting-up-gameplay' },
            { component: SettingUpGameplayStep2, group: 'Setting Up Gameplay', url: 'setting-up-gameplay/length-of-the-simulation' },
            { component: SettingUpGameplayStep3, group: 'Setting Up Gameplay', url: 'setting-up-gameplay/360-peer-review' },
            { component: SettingUpGameplayStep4, group: 'Setting Up Gameplay', url: 'setting-up-gameplay/grading' },
            { component: HowGradingWorksStep1, group: 'How Grading Works', url: 'how-grading-works' },
            { component: HowGradingWorksStep2, group: 'How Grading Works', url: 'how-grading-works/team-score' },
            { component: HowGradingWorksStep3, group: 'How Grading Works', url: 'how-grading-works/peer-score' },
            { component: HowGradingWorksStep4, group: 'How Grading Works', url: 'how-grading-works/engagement-score' },
            { component: HowGradingWorksStep5, group: 'How Grading Works', url: 'how-grading-works/individual-score' },
            { component: WhatToExpectStep1, group: 'What To Expect', url: 'what-to-expect' },
            { component: WhatToExpectStep2, group: 'What To Expect', url: 'what-to-expect/round1' },
            { component: WhatToExpectStep3, group: 'What To Expect', url: 'what-to-expect/round2' },
            { component: WhatToExpectStep4, group: 'What To Expect', url: 'what-to-expect/round3' },
            { component: WhatToExpectStep5, group: 'What To Expect', url: 'what-to-expect/promote-your-curriculum' },
            { component: HowWeSupportYou, group: 'How We Support You', url: 'how-we-support-you' },
            { component: NextSteps, group: 'Next Steps', url: 'next-steps' },
          ]
          : []),
      ],
      currentPage: -1,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { pages } = this.state;

    if (location.pathname === '/instructor/onboarding') {
      if (pages.length > 0) {
        changeLocation(`/instructor/onboarding/${pages[0].url}?round=${this.activeRound}`);
      }
    } else {
      const pathname = location.pathname.replace('/instructor/onboarding/', '');
      const currentPage = pages.findIndex(i => i.url === pathname);

      this.setState({
        currentPage,
      });
    }
  }

  componentDidUpdate() {
    const { location } = this.props;
    const { pages } = this.state;
    const pathname = location.pathname.replace('/instructor/onboarding/', '');
    const currentPage = pages.findIndex(i => i.url === pathname);

    if (currentPage !== this.state.currentPage) {
      this.setState({
        currentPage,
      });
    }
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return roundInUrl || currentRound;
  }

  goNext = e => {
    e.preventDefault();

    const { pages, currentPage } = this.state;

    if (currentPage >= 0 && currentPage < pages.length - 1) {
      const url = pages[currentPage + 1].url;

      changeLocation(`/instructor/onboarding/${url}?round=${this.activeRound}`);
    }
  }

  goPrev = e => {
    e.preventDefault();

    const { pages, currentPage } = this.state;

    if (currentPage > 0) {
      const url = pages[currentPage - 1].url;

      changeLocation(`/instructor/onboarding/${url}?round=${this.activeRound}`);
    }
  }

  render() {
    const {
      currentPage,
      pages,
    } = this.state;
    const { rounds } = this.props;
    const currentRound = this.activeRound;
    const ContentPage = currentPage > -1 ? pages[currentPage].component : Page404;

    return (
      <Wrapper>
        {pages.length > 0 && (
          <Navigation
            pages={pages}
            currentRound={currentRound}
          />
        )}
        <Content>
          {ContentPage && (
            <ContentPage
              currentRound={currentRound}
              rounds={rounds}
              stage="welcome"
            />
          )}
          {pages.length > 0 && (
            <Pagination
              goNext={this.goNext}
              goPrev={this.goPrev}
              currentPage={currentPage}
              pages={pages}
            />
          )}
        </Content>
      </Wrapper>
    );
  }

}

export default InstructorOnboardingPage;



// WEBPACK FOOTER //
// ./src/instructor/containers/onboarding.js